// A map's thumbnail: every slice's input quad in the server frame.
import { HEIGHT, THUMBNAIL_MIME, THUMBNAIL_QUALITY, THUMBNAIL_SIZE, WIDTH } from '~/lib/constants'

/** `data`'s thumbnail as a Blob, or null where the browser cannot encode one. */
export const mapThumbnail = data =>
	new Promise(resolve => {
		const W = THUMBNAIL_SIZE
		const H = Math.round((W * HEIGHT) / WIDTH)
		const canvas = document.createElement('canvas')
		canvas.width = W
		canvas.height = H
		const c = canvas.getContext('2d')
		c.fillStyle = '#000'
		c.fillRect(0, 0, W, H)
		c.strokeStyle = 'rgb(255 255 255 / 0.25)'
		c.lineWidth = 1
		c.strokeRect(0.5, 0.5, W - 1, H - 1)
		c.lineJoin = 'round'
		for (const { input } of Object.values(data?.slices ?? {})) {
			c.beginPath()
			input.forEach(([u, v], i) => c[i ? 'lineTo' : 'moveTo'](u * W, v * H))
			c.closePath()
			c.fillStyle = 'rgb(255 212 121 / 0.2)'
			c.fill()
			c.strokeStyle = '#ffd479'
			c.lineWidth = 2
			c.stroke()
		}
		canvas.toBlob(resolve, THUMBNAIL_MIME, THUMBNAIL_QUALITY)
	})
